import HYRequest from "./request";
import { BASE_URL, TIME_OUT } from "./config";
import type { HYRequestConfig } from "./type";
const hyRequest = new HYRequest({
	baseURL: BASE_URL,
	timeout: TIME_OUT
});
export const _$get = (config: HYRequestConfig): Promise<any> => {
	return hyRequest.request<unknown>({ ...config, method: "get" });
};
export const _$post = (config: HYRequestConfig): Promise<any> => {
	return hyRequest.request<unknown>({ ...config, method: "post" });
};
export const _$delete = (config: HYRequestConfig): Promise<any> => {
	return hyRequest.request<unknown>({ ...config, method: "delete" });
};
export const _$put = (config: HYRequestConfig): Promise<any> => {
	return hyRequest.request<unknown>({ ...config, method: "put" });
};
export default hyRequest;
